// Data that configures the Player Defensive Table
import { defensiveTeamTableRowItems } from '@/utils/dataTablesStructures/team';
import baseColumns from '@/data/team/baseColumns';

export default {
  columns: baseColumns,
  expandedRows: defensiveTeamTableRowItems.map(item => {
    if (!item.categoryIds) {
      return item.category;
    }
  }),
};
